export const calcSalary = (bigItems, smallItems, payment) => {
	return (
		Math.round(
			(bigItems * payment.delivered_commision +
				smallItems * payment.additional_item_commision) *
				100,
		) / 100
	);
};
